import React from 'react';
import { isNullOrUndefined } from 'util';

export default class TextAreaInput extends React.Component {
    constructor(args) {
        super(args);

        this.state = {
            value: this.clearValue(this.props.value)
        };
    }

    componentWillReceiveProps(newProps) {
        let value = this.clearValue(newProps.value);
        this.setState({ value: value });
    }

    clearValue(value) {
        if (isNullOrUndefined(value)) {
            return "";
        } else {
            return "" + value;
        }
    }

    handleInputValueChanged(e) {
        let value = this.clearValue(e.target.value);
        this.setState({ value: value });
        let fieldValue = value === "" ? null : value;
        if (this.props.onChange) {
            this.props.onChange(fieldValue);
        }
    }

    handleInputBlur() {
        if (this.props.onEditComplete) {
            this.props.onEditComplete();
        }
    }

    handleInputKeyDown(e) {
        if (e.keyCode === 13 && (e.ctrlKey || e.shiftKey)) {
            this.handleInputBlur();
        }
    }

    render() {
        return (
            <textarea className={"form-control " + (this.props.className ? this.props.className : "")}
                rows="4"
                id={this.props.id}
                title={this.props.title}
                value={this.state.value}
                onChange={e => this.handleInputValueChanged(e)}
                onBlur={() => this.handleInputBlur()}
                onKeyDown={e => this.handleInputKeyDown(e)}
                disabled={this.props.disabled}
            />
        );
    }
}


// WEBPACK FOOTER //
// ./App/controls/textAreaInput.jsx